<template>
  <div class="app-wrapper" :class="{ collapse: isCollapse }">
    <!-- 左侧菜单 -->
    <div class="sidebar-container">
      <div class="logo-container">
        <h1 class="logo">管理系统</h1>
      </div>
      <el-scrollbar>
        <el-menu
          :default-active="activeMenu"
          :collapse="isCollapse"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          unique-opened
          router
        >
          <sidebar-item 
            v-for="route in sidebarRoutes" 
            :key="route.path" 
            :item="route" 
            :base-path="route.path.startsWith('/') ? route.path : '/' + route.path" 
          />
        </el-menu>
      </el-scrollbar>
    </div>
    
    <!-- 右侧内容 -->
    <div class="main-container">
      <!-- 顶部导航 -->
      <div class="navbar">
        <div class="left-menu">
          <div class="collapse-btn" @click="toggleSidebar">
            <el-icon v-if="isCollapse"><Expand /></el-icon>
            <el-icon v-else><Fold /></el-icon>
          </div>
          <breadcrumb />
        </div>
        <div class="right-menu">
          <!-- 环境切换器 -->
          <env-switcher />
          
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="avatar-container">
              <el-avatar :size="30" :src="userInfo.avatar" />
              <span class="username">{{userInfo.username}}</span>
              <el-icon><CaretBottom /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">个人信息</el-dropdown-item>
               <!-- <el-dropdown-item command="password">修改密码</el-dropdown-item> -->
                <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      
      <!-- 主要内容区域 -->
      <app-main />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessageBox } from 'element-plus'
import SidebarItem from './components/SidebarItem.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import AppMain from './components/AppMain.vue'
import EnvSwitcher from '@/components/EnvSwitcher.vue'
import { getAuthInfo, getMenus } from '@/api'

const store = useStore()
const router = useRouter()
const route = useRoute()
// const userInfo = toRaw(store.state.userInfo)
const userInfo = ref({})

// getAuthInfo().then(res=> {
// 	console.log('----',res)
	userInfo.value = JSON.parse(localStorage.getItem("userInfo"))
// userInfo.value = JSON.parse(userInfo.value)
console.log('userInfo',userInfo.value)
// })

// 侧边栏折叠状态
const isCollapse = computed(() => store.getters.isCollapse)

// 当前激活的菜单
const activeMenu = computed(() => {
  return route.path
})

// 从路由配置中获取侧边栏菜单
const sidebarRoutes = computed(() => {
  // 获取路由配置中的主布局子路由
  const routes = router.options.routes.find(route => route.path === '/' && route.component)
  return routes ? routes.children : []
})

// 切换侧边栏折叠状态
const toggleSidebar = () => {
  store.dispatch('toggleSidebar')
}

// 下拉菜单操作
const handleCommand = (command) => {
  switch (command) {
    case 'profile':
      router.push('/user/profile')
      break
    case 'password':
      router.push('/setting/password')
      break
    case 'logout':
      ElMessageBox.confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('logout').then(() => {
          router.push('/login')
        })
      }).catch(() => {})
      break
  }
}

// getMenus().then(res=> {
// 	console.log('获取的一级菜单：',res)
// })
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  
  // 侧边栏
  .sidebar-container {
    width: 210px;
    height: 100%;
    background: #304156;
    transition: width 0.28s;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    
    .logo-container {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      
      .logo {
        color: #fff;
        font-size: 18px;
        margin: 0;
        white-space: nowrap;
      }
    }
    
    .el-scrollbar {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      
      &::-webkit-scrollbar {
        width: 4px;
      }
      
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 2px;
        
        &:hover {
          background: rgba(255, 255, 255, 0.3);
        }
      }
    }
    
    .el-menu {
      border-right: none;
    }
  }
  
  // 主内容区
  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    
    // 顶部导航
    .navbar {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      
      .left-menu {
        display: flex;
        align-items: center;
        
        .collapse-btn {
          padding: 0 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      
      .right-menu {
        display: flex;
        align-items: center;
        gap: 15px;
        
        .avatar-container {
          display: flex;
          align-items: center;
          cursor: pointer;
          
          .username {
            margin: 0 5px;
          }
        }
      }
    }
  }
  
  // 折叠状态
  &.collapse {
    .sidebar-container {
      width: 64px;
      
      .logo-container {
        .logo {
          display: none;
        }
      }
    }
  }
}
</style> 